import React from 'react';
import { Thermometer } from 'lucide-react';
import styles from './ContainerSleeveHero.module.css';

const ContainerSleeveHero = ({
  badge,
  scriptTitle,
  mainTitleLines,
  kicker,
  descriptions,
  features,
  images,
  stampLabel = 'Insulated',
}) => (
  <section className={styles.heroSection}>
    <div className={styles.gridBg} aria-hidden="true" />

    <div className={styles.inner}>
      <div className={styles.layout}>
        <div className={styles.copyCol}>
          <span className={styles.badge}>{badge}</span>

          <div className={styles.titleBlock}>
            <span className={styles.eyebrow}>{scriptTitle}</span>
            <h1 className={styles.title}>
              {mainTitleLines[0]}
              <span className={styles.titleAccent}>{mainTitleLines[1]}</span>
            </h1>
          </div>

          {kicker && <p className={styles.kicker}>{kicker}</p>}

          <div className={styles.bodyCopy}>
            {descriptions.slice(0, 2).map((text, index) => (
              <p key={index} className={styles.paragraph}>
                {text}
              </p>
            ))}
          </div>

          {features?.length > 0 && (
            <ul className={styles.featureRow}>
              {features.map((feature, index) => (
                <li key={index} className={styles.featureChip}>
                  <Thermometer size={11} aria-hidden="true" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className={styles.wrapCol}>
          <div className={styles.wrapGrid}>
            {images[0] && (
              <figure className={styles.cellTall}>
                <img src={images[0].src} alt={images[0].alt} />
              </figure>
            )}
            {images[1] && (
              <figure className={styles.cellTop}>
                <img src={images[1].src} alt={images[1].alt} />
              </figure>
            )}
            {images[2] && (
              <figure className={styles.cellWide}>
                <img src={images[2].src} alt={images[2].alt} />
              </figure>
            )}
          </div>

          {stampLabel && (
            <div className={styles.insulateBadge}>
              <Thermometer size={13} aria-hidden="true" />
              <span>{stampLabel}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  </section>
);

export default ContainerSleeveHero;
